import { render } from "./red-he.vue?vue&type=template&id=07c3ba65&scoped=true"
import script from "./red-he.vue?vue&type=script&lang=js"
export * from "./red-he.vue?vue&type=script&lang=js"

import "./red-he.vue?vue&type=style&index=0&id=07c3ba65&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c3ba65"]])

export default __exports__